export default {
  anchorEditor: true,
  anchorPreview: true,
  attributeInserter: true,
  textFormatter: true,
  allowMention: true,
  allowAlignment: true,
  allowAttribute: true,
  allowBold: true,
  allowItalic: true,
  allowAnchor: true,
  allowHeading: true,
  allowSubheading: true,
  allowOrderedList: true,
  allowUnorderedList: true,
  allowImage: true,
  allowButton: true,
  allowVideo: true,
  allowVideoFile: true,
  allowSocial: true,
  allowCode: true,
  allowHtml: true,
  allowAttachments: true,
  allowEmoji: true,
  readOnly: false,
  displaySocialBlocksAsButtons: false,
  urlReplacement: true,
  // Perform automatic conversion of URLs to anchors
  markdownLinks: true,
  // Convert markdown links to anchors
  markdownInlineCode: true,
  autoFocusTopLeft: true,
  recoverErrors: false,
  allowRtl: true,
  allowImageText: true
};